module.exports = __webpack_public_path__ + "img/16129835946.TNSC.9aeed347.svg";